import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="bg-dark text-white text-center py-2 small">
      © {new Date().getFullYear()} HRMS System · All Rights Reserved
    </footer>
  );
};

export default Footer;
